import React from "react";
import { Link } from "react-router-dom";
import { ROUTES } from "../routes";
import "./SiteFooter.css";

const FOOTER_TOOLS = [
  { to: ROUTES.carAffordability, label: "Car affordability" },
  { to: ROUTES.homeAffordability, label: "Home affordability" },
  { to: ROUTES.bondRepayment, label: "Bond repayment" },
  { to: ROUTES.tax, label: "Tax calculator" },
  { to: ROUTES.monthlyFinances, label: "Monthly finances" },
] as const;

const SiteFooter: React.FC = () => (
  <footer className="site-footer">
    <nav className="site-footer-nav" aria-label="Site">
      <Link to={ROUTES.home}>Home</Link>
      {FOOTER_TOOLS.map(({ to, label }) => (
        <Link key={to} to={to}>
          {label}
        </Link>
      ))}
      <Link to={ROUTES.about}>About</Link>
    </nav>
    <p className="site-footer-support">
      Find this useful?{" "}
      <a
        href="https://www.buymeacoffee.com/totties"
        target="_blank"
        rel="noopener noreferrer"
      >
        Buy me a coffee
      </a>
    </p>
    <p className="site-footer-legal">
      Totties is for informational purposes only and does not constitute
      financial advice.
    </p>
  </footer>
);

export default SiteFooter;
